import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const SPECIFICATION_TABLE_HEADERS = [
  "Sr No.",
  "Product Name",
  "Subproduct Name",
  "Make",
  "Model",
  "Variant",
  "Variant Color",
  "Status",
  "Actions"
];

export const SPECIFICATION_TABLE_DATA = [
  { id: 1, productName: "Car", subproductName: "Sedan", make: "Toyota", model: "Camry", variant: "XLE", variantColor: "Red", status: "Active", actions: "Edit/Delete" },
  { id: 2, productName: "Car", subproductName: "SUV", make: "Honda", model: "CR-V", variant: "Touring", variantColor: "Blue", status: "Inactive", actions: "Edit/Delete" },
  { id: 3, productName: "Bike", subproductName: "Sport", make: "Yamaha", model: "R1", variant: "M", variantColor: "Black", status: "Active", actions: "Edit/Delete" },
  { id: 4, productName: "Truck", subproductName: "Mini", make: "Ford", model: "Ranger", variant: "XL", variantColor: "White", status: "Active", actions: "Edit/Delete" },
  // Add more data as needed
];

export const specificationKeyMapping = {
  "Sr No.": "id",
  "Product Name": "productName",
  "Subproduct Name": "subproductName",
  "Make": "make",
  "Model": "model",
  "Variant": "variant",
  "Variant Color": "variantColor",
  "Status": "status",
  "Actions": [
    { type: "view", icon: eyeIcon, label: "View" },
    { type: "edit", icon: editIcon, label: "Edit" },
  ]
};
